module.exports = __webpack_public_path__ + "assets/icons/ic_work_outline_thin_24px.svg";